var CSS_BODY_OVERFLOW_CLASS = 'overflow-hidden';
var CSS_VISIBLE_CLASS = 'mobile-nav--is-visible';
var CSS_HIDDEN_CLASS = 'mobile-nav--is-hidden';
var JS_TRIGGER_SELECTOR = '.js-mobile-nav-trigger';
var DATA_ATTR_TARGET_KEY = 'mobileNavTarget';
var bodyEl = null;
// I could do caching for this, but its so infrequent just searching the DOM adhoc seems ok
function getTriggerTarget(triggerEl) {
    var _a;
    var id = (_a = triggerEl.dataset[DATA_ATTR_TARGET_KEY]) !== null && _a !== void 0 ? _a : null;
    if (id) {
        return document.getElementById(id);
    }
    return null;
}
function show(el) {
    if (el) {
        el.classList.add(CSS_VISIBLE_CLASS);
        el.classList.remove(CSS_HIDDEN_CLASS);
    }
    if (bodyEl) {
        bodyEl.classList.add(CSS_BODY_OVERFLOW_CLASS);
    }
}
function hide(el) {
    if (el) {
        el.classList.remove(CSS_VISIBLE_CLASS);
        el.classList.add(CSS_HIDDEN_CLASS);
    }
    if (bodyEl) {
        bodyEl.classList.remove(CSS_BODY_OVERFLOW_CLASS);
    }
}
function handleClick(evt) {
    evt.preventDefault();
    if (evt.currentTarget) {
        var navEl = getTriggerTarget(evt.currentTarget);
        if (navEl) {
            if (navEl.classList.contains(CSS_VISIBLE_CLASS)) {
                hide(navEl);
            }
            else {
                show(navEl);
            }
        }
    }
    return false;
}
export function mobileNavInit() {
    bodyEl = document.querySelector('body');
    var triggers = Array.from(document.querySelectorAll(JS_TRIGGER_SELECTOR));
    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', handleClick);
    });
}
